import {cloneDeep} from "lodash-es";
import BlockoutValidationService from "app/services/blockoutValidation/blockoutValidation.service";

const NS = 'YearlyValidDay'; // jshint ignore:line

export default function YearlyValidDay($timeout: any) { // as yearlyValidDay
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope: any, element: any, attrs: any, ngModel: any) {

    const validate = function (viewValue: any) {
      const selectedMonth = attrs.yearlyValidDay;

      if (!ngModel.$modelValue || !ngModel.$viewValue) {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('yearly-valid-day', true);
        $timeout(function () {
          validate(ngModel.$viewValue);
        }, 1000);
      } else {
        const valid = BlockoutValidationService.isYearlyDayValid(viewValue, selectedMonth);

        ngModel.$setValidity('yearly-valid-day', valid);
      }
      return viewValue;
    };

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('yearlyValidDay', function () {
      // Whenever the comparison model changes we'll re-validate
      validate(ngModel.$viewValue);
    });
  }
}
